<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
    <!-- <keep-alive include="yearlyInspection">
      <component></component>
    </keep-alive> -->
  </div>
</template>

<script>
// localStorage.setItem('access_token', '0815cHFa11UZAG0xN2Ia10qeWz45cHFFpEdirN6kzNoWlhWl72OukuCv6AEDcCPA');
// localStorage.setItem('userinfo', JSON.stringify({
//   "access_token": "0815cHFa11UZAG0xN2Ia10qeWz45cHFFpEdirN6kzNoWlhWl72OukuCv6AEDcCPA",
//   "avatar": "http://thirdwx.qlogo.cn/mmopen/vi_32/4kF5cFK9MN4cbwicDtc1RpcmUL32dj4FkwNI8eDAY5sEnrgzbNV4HjoaibYGkXdshTGxLShOUWNQS71lW52b0HLw/132",
//   "expires_in": 86300,
//   "id": 42,
//   "mobile": "18825066869",
//   "nickname": "🍅",
//   "sex": 1
// }))

// localStorage.setItem(
//   "access_token",
//   "061EtZFa1nLGeM0s9GFa13VR412EtZFzd-3FpK17Cd6u487H1cFaKFOrHVWeQAJN"
// );
// localStorage.setItem(
//   "userinfo",
//   JSON.stringify({
//     id: 25,
//     nickname: "乐多~",
//     sex: 0,
//     avatar:
//       "http://thirdwx.qlogo.cn/mmopen/vi_32/UVlfwia03ZcTm2W723pvbkKbJo6eNRjHljS5IAfWYWbo2HCZDa0kfSXajxKrOwvHg9iagE4YcTx4bF7VzyJ69wng/132",
//     mobile: "15236292526",
//     access_token:
//       "061EtZFa1nLGeM0s9GFa13VR412EtZFzd-3FpK17Cd6u487H1cFaKFOrHVWeQAJN",
//     expires_in: 86300
//   })
// );
export default {
  name: "App"
};
</script>

<style>
/* #app {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
    } */
input {
  font-size: 18px;
}

input:focus {
  outline-offset: 0;
}

:focus {
  outline: none;
}

button {
  margin: 10px auto !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

body {
  margin: 0;
  /* background: #F0F0F0; */
  /* //background: #FFFFFF; */
  font-size: 14px;
}

.weui-loadmore__tips_in-line {
  background-color: #f2f2f2;
}

.weui-cell {
  padding: 7.5px 15px;
}

/* 颜色同weui输入框占位符 */
.grayColor {
  color: #808080;
}

/* 颜色同weui标题、提醒,比默认页面背景色(#f2f2f2)深一点,但比.grayColor浅一点 */
.greyColor {
  color: #999;
}

/* 颜色比weui-cell_active背景色(#ececec)浅一点 */
.grayBg {
  background-color: #f8f8f8;
}

/* 通用样式(方便修改 */
.commonBg {
  background-color: #da251c !important;
}

.commonColor {
  color: #da251c !important;
}

.commonBold {
  color: #da251c;
  font-weight: bold;
}

.commonBorder {
  border: 1px solid #da251c !important;
  color: #da251c !important;
}

.commonShadow {
  box-shadow: 0 10px 10px #e64e13;
  /* box-shadow: 0 10px 10px #DF3818; */
}

button {
  font-size: 17.5px;
  font-weight: bold;
}

button[type="primary"] {
  background-color: #da251c;
  box-shadow: 0 10px 10px #e3e3e3;
}

.button-hover[type="primary"] {
  background-color: rgba(218, 37, 28, 0.9);
  box-shadow: 0 10px 10px #e3e3e3;
}

button[disabled][type="primary"] {
  background-color: rgba(218, 37, 28, 0.6);
}

.weui-bar__item_on .weui-navbar__title {
  color: #da251c;
}

.weui-navbar__slider {
  background-color: #da251c;
}

.weui-cells::before {
  border-top: 0;
}

.weui-cells::after {
  border-bottom: 0;
}

.weui-cells {
  font-size: 15px;
}

.weui-cell::before {
  border-top: 1px solid #f5f5f5;
}

.section {
  background-color: #fff;
  margin: 30px 15px 0;
  border-radius: 5px;
  box-shadow: 0 10px 10px #e3e3e3;
  display: flex;
  flex-direction: column;
  position: relative;
}

.section:first-child {
  margin-top: 0;
}

.page_tab {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.page_tablist {
  height: 100%;
  position: relative;
}

.page_tabname {
  height: 100%;
  display: flex;
  font-size: 13px;
  align-items: center;
}

.page_tabname::after {
  content: "";
  top: auto;
  bottom: 0;
  width: 40%;
  position: absolute;
  left: 25%;
  height: 3px;
  background-color: #fd8c00;
}

.page_tabname1 {
  height: 100%;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.page_top {
  width: 90%;
  height: 184px;
  background: #fd8c00;
  padding: 20px;
  position: relative;
  color: #fff;
}

.page_topmine {
  width: 100%;
  height: 184px;
  background-size: cover;
  background-color: #fd8c00;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  color: #fff;
}

.page_pname {
  color: hsla(0, 0%, 100%, 1);
  padding: 0 10px;
}

.page_pnum {
  display: flex;
  align-items: center;
  margin-top: 10px;
  border-bottom: 1px solid hsla(0, 0%, 100%, 1);
  justify-content: space-between;
  padding: 10px;
}

.page_pnuminput {
  background-color: transparent;
  border: none;
  color: #fff;
}

/*  ::-webkit-input-placeholder {
    text-align: start;
    color: hsla(0, 0%, 100%, 1);
    font-size: 16px;
  } */

.page_pimg {
  width: 20px;
  height: 20px;
}

/* .page_taocan {
    width: 84%;
    height: 191px;
    padding: 23px 10px;
    margin: 0 20px;
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 5px;
    position: absolute;
    top: 180px;
    background-color: #fff;
  } */
.page_taocan {
  /* width: 84%; */
  width: calc(100% - 40px);
  height: 191px;
  padding: 20px 10px;
  box-sizing: border-box;
  margin: 0 20px;
  box-shadow: 0 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  position: relative;
  /*  top: 180px; */
  top: -85px;
  background-color: #fff;
}

.page_taocan_name {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(53, 53, 53, 1);
}

.page_taocan_list {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-evenly; */
  /* align-items: center; */
}

.page_taocan_box {
  /* width: 96px; */
  width: 30%;
  height: 46px;
  font-weight: 400;
  color: rgba(54, 54, 54, 1);
  border: 1px solid rgba(124, 124, 124, 1);
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 0 5px;
  box-sizing: border-box;
}

.page_taocan_box1 {
  /* width: 96px; */
  width: 30%;
  height: 46px;
  font-weight: bold;
  color: #fd8c00;
  background: rgba(253, 140, 0, 0.1);
  border: 1px solid rgba(253, 140, 0, 1);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

.page_taocan_num {
  font-size: 14px;
}

.page_pnuminput {
  background-color: transparent;
  border: none;
  color: rgba(53, 53, 53, 1);
}

/*    .page_taocan_check {
      width: 0;
      height: 0;
      border-bottom: 20px solid rgba(254, 117, 91, 1);
      border-left: 20px solid transparent;
      position: absolute;
      bottom: 0;
      right: 0;
    } */

.page_taocan_checkimg {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
}

/* .page_button {
    margin: 150px 30px 0 30px;
    height: 10px;
    width: 82%;
    height: 46px;
    background: linear-gradient(90deg, rgba(9, 121, 255, 1) 0%, rgba(2, 157, 255, 1) 100%);
    box-shadow: 0px 5px 7px 2px rgba(3, 157, 255, 0.3);
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
  } */
.page_button {
  margin: 0 30px;
  width: 82%;
  /*  padding: 10px; 150px 30px*/
  height: 46px;
  background: #fd8c00;
  /* //box-shadow: 0 5px 7px 2px rgba(3, 157, 255, 0.3); */
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.page_zhifu {
}

.page_mesg {
  width: 89%;
  padding: 20px;
}

.page_mesgtitle {
  display: flex;
}

.page_mesgimg {
  width: 4px;
  height: 23px;
  margin-right: 10px;
}

.page_mesgtext {
}

.page_mesgtip {
  margin-left: 20px;
}

.page_mesgtipspan {
  color: #fd8c00;
}

.page_select {
  height: 90px;
  width: 100%;
  display: flex;

  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.page_jia {
  width: 40px;
  height: 40px;
}

.page_jianame {
  font-size: 17px;
}

.page_none {
  /* width: 100%;
    height: 100%; */
  position: absolute;
  top: 30%;
  /* left: 35%; */
  left: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page_none_icon {
  /*  width: 140px;
    height: 140px; */
  width: 120px;
  height: 120px;
}

.page_inputfrom {
  display: flex;
  align-items: center;
}

.page_checkinput {
  font-size: 14px;
  font-weight: 400;
  line-height: 23px;
  border: none;
  background-color: #fff;
  width: 180px;
}

.pagetype_taocan {
  width: calc(100% - 40px);
  margin: 20px;
  box-shadow: 0 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  padding: 20px 10px;
  box-sizing: border-box;
}

.page_shangpin_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.page_shangpin_mesgname {
  font-size: 11px;
  font-weight: 400;
  color: rgba(101, 101, 101, 1);
}

.page_shangpin_mesgname1 {
  font-size: 15px;
  font-weight: 400;
  color: rgba(53, 53, 53, 1);
  display: flex;
  align-items: center;
}

.page_shangpin_mesglogo {
  width: 17px;
  height: 17px;
  margin-right: 10px;
}

.page_shangpin_shoujia {
  font-size: 11px;
  font-weight: 400;
  color: #fd8c00;
}

.page_shangpin_usejifen {
  display: flex;
  align-items: center;
}

.page_shangpin_keyong {
  font-size: 12px;
  color: #666666;
  margin-right: 10px;
}

.page_checklogo {
  width: 15px;
  height: 15px;
  margin-left: 10px;
}

.pagepaytype_text {
  font-size: 14px;
}

.page_topbox {
  width: 100%;
  height: 50px;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  background-color: #ffffff;
  z-index: 2;
  top: 0;
}

.page_topreturn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.page_toptext {
  font-size: 18px;
}

.page_topreturnindex {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue